import { twMerge } from 'tailwind-merge';
import { InputHTMLAttributes } from 'react';

type InputProps = {
    invalid?: boolean
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

export const Checkbox = ({ invalid, disabled, ...rest }: InputProps) => {
    return (
        <input
            {...rest}
            type={'checkbox'}
            disabled={disabled}
            defaultChecked={undefined}
            className={twMerge(
                'form-checkbox size-4 rounded-sm text-primary bg-surface-3 border-gray-300 focus:ring-primary',
                disabled && 'cursor-not-allowed bg-surface-1',
                invalid && 'border-error focus:border-error focus-visible:ring-error'
            )}
        />
    );
}
